//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../Diagramming/Diagramming.BaseObjectBuilder.js";
let d=[[[0,"AllowJumpers",1,0],[0,"Description",1,0],[0,"JumperType",1,0],[0,"Opacity",1,0],[0,"PaxFileName",1,0],[0,"PresentationName",1,0],[0,"ToolTip",1,0],[0,"Units",1,"Unit",0],[0,"UpdatePAXFile",1,0]],[[["numFeatures"],"GetFeatures",{R_:{features:"Diagramming.SheetElement[]"}},0,0],[["numSheetElements"],"GetSheetElements",{R_:{sheetElements:"Diagramming.SheetElement[]"}},0,0],[["height","width"],"GetSize",{},0,0],[["height","width"],"SetSize",{},2,0]],[]];
SPLM.Diagramming.SheetBuilder = class extends SPLM.Diagramming.BaseObjectBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.SheetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;